import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardPamong } from 'app/KinerjaPamongPage/components/PageGuardPamong'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import { Homepage } from 'app/KinerjaPamongPage/pages/pegawai/Homepage'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaPamongPegawaiIndex = () => {
  return (
    <PageGuardPamong>
      <KinerjaTipeProvider tipe="SPNF">
        <Homepage />
      </KinerjaTipeProvider>
    </PageGuardPamong>
  )
}

KinerjaPamongPegawaiIndex.Layout = KinerjaLayout

KinerjaPamongPegawaiIndex.layoutOpts = {
  hasHeader: true,
}

export default KinerjaPamongPegawaiIndex
